import React, { useCallback, useRef, useState, useEffect } from 'react';
import { withStyles, Typography, Tooltip, IconButton, Button, Dialog, DialogTitle, Grid, } from '@material-ui/core';
import { connect } from 'react-redux';
import TransportColliList from './TransportColliList';
import { hasPermission, createHistory, hasAtLeastOnePermission, formatDate, parseURL } from '../../sc-utilities';
import { FindInPage, Delete, LibraryBooks, LibraryBooksTwoTone, Dvr, DevicesOther, SdCard, CloudUpload, AllInbox, Headset, Watch } from '@material-ui/icons';
import * as actions from './store/transportColliActions';
import * as groupActions from "../../sc-group/Group/store/groupActions";
import * as pcActions from '../../sc-product/PCProduct/store/pcProductActions';
import AppLogoLoading from "../../sc-logo";
import { getGroupsLookup } from '../../sc-dashboard/ProductOverview/ProductsAll';
import { checkIfLoading } from "../../sc-users/User";
import { Redirect } from 'react-router-dom';
import ExportForm from '../../sc-components/ExportForm/ExportForm';
import ConfirmationDialog from '../../np-components/ConfirmationDialog/ConfirmationDialog';

const styles = theme => ({
    root: {
        width: `98.9%`,
        height: 'auto',
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    },
    paletteButtons: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.buttonText.default,
        margin: theme.spacing(),
        minWidth: '24px',
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
    },
    "@global": {
        "[class*='paletteButtons']": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.buttonText.default,
            margin: theme.spacing(),
            minWidth: '24px',
            borderRadius: '1px',
            '&:hover': {
                backgroundColor: theme.palette.secondary.main,
            },
        },
        "[class*='button']": {
            textTransform: 'none',
            textDecoration: 'none'
        }
    },
    button: {
        textTransform: 'none',
        textDecoration: 'none'
    },
    loading: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    }
});

let initialValues = [
    'Excel',
    'JSON',
    'CSV',
    'XML',
    'Download',
    "Email",
    "includePDFReports",
    "includeDiagnoseReports",
    "includeVerificationReports",
    "includeAggregatedPDFErasureReports",
    "includeAggregatedPDFVerificationReports",
    "includeSummaryPDFErasureReports",
    "includeSummaryPDFVerificationReports",
];

const TransportColli = props => {
    const tableRef = useRef();
    const { classes, translations, permissions, activeExternalServiceAvailable, activeCustomerID, columns, onBulkGenerateReport, fetchGroups, onSendExternalData, onSendErasureReports } = props;
    let visible = columns && columns['TransportColli'];
    const [redirectOptions, setRedirectOptions] = useState({ redirect: false, TransportColliID: null, redirectPath: "", search: '' });
    const [groups, setGroups] = useState(null);
    const [loading, setLoading] = useState({ groups: false });
    const [collectionCreatePopupIsOpen, setCollectionCreatePopupIsOpen] = useState(false);
    const [rowData, setRowData] = useState(null);
    const [confirmDialog, setConfirmDialog] = useState({ open: false, confirmed: false, type: '', title: '' });

    const handleOpenDialog = (rowData, type, title) => {
        setConfirmDialog({ open: true, type, title });
        setRowData(rowData);  
    };

    const defaultFilter = parseURL(window.location.search)

    const formSettings = {
        Validation: {},
        FormTitle: translations["create_collection"] || "Create collection",
        ButtonSubmit: {
            Title: translations["download"] || "Download",
            Color: 'primary'
        },
        InitialValues: { GroupID: groups?.map(group => group.value)?.includes('n/a') ? 'n/a' : groups?.[0]?.value ?? null }
    };

    const tableActionsRow = [
        {
            icon: 'FindInPage',
            tooltip: translations['transport_colli_details'] || "Transport colli details",
            onClick: (event, rowData) => goToTransportColliDetails(event, rowData),
            hidden: !hasPermission(permissions, "transport_colli_load")
        },
        {
            icon: 'LibraryBooks',
            hidden: !hasPermission(permissions, "transport_colli_generate_report"),
            tooltip: translations['create_collection'] || "Create collection",
            onClick: (event, rowData) => { 
                setRowData(rowData);  
                setCollectionCreatePopupIsOpen(true);
            },
        },
        {
            icon: 'Dvr',
            hidden: !hasPermission(permissions, "product_list"),
            tooltip: translations["go_to_pc_products"] || "Go to PC products",
            onClick: (event, rowData) => goToPCProducts(event, rowData),
        },
        {
            icon: 'DevicesOther',
            hidden: !hasPermission(permissions, "product_list"),
            tooltip: translations["go_to_mobile_products"] || "Go to Mobile products",
            onClick: (event, rowData) => goToMobileProducts(event, rowData),
        },
        {
            icon: 'SdCard',
            hidden: !hasPermission(permissions, "product_list"),
            tooltip: translations["go_to_storage_products"] || "Go to Storage products",
            onClick: (event, rowData) => goToStorageProducts(event, rowData),
        },
        {
            icon: 'Headphone',
            hidden: !hasPermission(permissions, "product_list"),
            tooltip: translations["go_to_headphone_products"] || "Go to headphone products",
            onClick: (event, rowData) => goToHeadphoneProducts(event, rowData),
        },
        {
            icon: 'Watch',
            hidden: !hasPermission(permissions, "product_list"),
            tooltip: translations["go_to_watch_products"] || "Go to watch products",
            onClick: (event, rowData) => goToWatchProducts(event, rowData),
        },
        {
            icon: 'CloudUpload',
            tooltip: translations['send_external_data'] || "Send external data",
            onClick: (event, rowData) => handleOpenDialog(rowData, 'data', translations['sure_want_to_resend_data_for_lot'] || `Are you sure you want to re-send data for the whole Lot?`),
            hidden: !hasPermission(permissions, 'product_send_external_data')
        },
        {
            icon: 'AllInbox',
            tooltip: translations['send_erasure_reports'] || "Send erasure reports",
            onClick: (event, rowData) => handleOpenDialog(rowData, 'report', translations['sure_want_to_resend_reports_for_lot'] || `Are you sure you want to re-send erasure reports for the whole Lot?`),
            hidden: !hasPermission(permissions, 'product_send_erasure_report')
        },
    ];

    useEffect(() => {
        const getGroups = async () => {
            setLoading(prevState => { return { ...prevState, groups: true } });
            const resultGroups = await fetchGroups({ ActiveCustomerID: activeCustomerID });
            if (resultGroups) {
                setGroups(resultGroups.data);
            }
            setLoading(prevState => { return { ...prevState, groups: false } });
        }

        if (hasPermission(permissions, 'group_list')) {
            getGroups();
        }
        // eslint-disable-next-line
    }, []);

    const groupsLookup = getGroupsLookup(groups, translations, permissions);

    const sendExternalData = useCallback(async (transportColliID) => {
        await onSendExternalData({ TransportColliID: transportColliID, ActiveCustomerID: activeCustomerID })
    }, [activeCustomerID, onSendExternalData]);

    const sendErasureReports = useCallback(async (transportColliID) => {
        await onSendErasureReports({ TransportColliID: transportColliID, ActiveCustomerID: activeCustomerID })
    }, [activeCustomerID, onSendErasureReports]);

    useEffect(() => {
        if (confirmDialog.confirmed) {
            if (confirmDialog.type === 'data') {
                sendExternalData(rowData.TransportColliID);
            } else if (confirmDialog.type === 'report') {
                sendErasureReports(rowData.TransportColliID);
            }
        }
    }, [confirmDialog.confirmed, confirmDialog.type, rowData?.TransportColliID, sendExternalData, sendErasureReports]);

    const getIcon = icon => {
        switch (icon) {
            case 'FindInPage':
                return <FindInPage />
            case 'Delete':
                return <Delete />
            case 'LibraryBooks':
                return <LibraryBooks />
            case 'LibraryBooksTwoTone':
                return <LibraryBooksTwoTone />
            case 'Dvr':
                return <Dvr />
            case 'DevicesOther':
                return <DevicesOther />
            case 'SdCard':
                return <SdCard />
            case 'CloudUpload':
                return <CloudUpload />
            case 'AllInbox':
                return <AllInbox />
            case 'Headphone':
                return <Headset />
            case 'Watch':
                return <Watch />
            default:
                return <SdCard />
        }
    }

    let tableColumns = [
        {
            title: translations["action"] || "Action", field: 'Action',
            hidden: visible ? visible['Action'] : false,
            cellStyle: { minWidth: 340, maxWidth: 340 },
            filtering: false,
            render: rowData => {
                return tableActionsRow.map(action => {
                    if (action.hidden) {
                        return null;
                    }
                    return (
                        <Tooltip key={`${action.icon}-${rowData.TransportColliID}`} title={action.tooltip}>
                            <IconButton
                                component='div'
                                onClick={(event) => action.onClick(event, rowData)}
                            >
                                {
                                    getIcon(action.icon)
                                }
                            </IconButton>
                        </Tooltip>
                    )
                })
            },
        },
        {
            title: translations["id"] || "ID", field: 'TransportColliInventoryID',
            hidden: visible ? visible['TransportColliInventoryID'] : false,
            cellStyle: {
                width: 80,
                minWidth: 80
            },
            defaultFilter: `${defaultFilter && defaultFilter.TransportColliInventoryID ? defaultFilter.TransportColliInventoryID : ''}`,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.TransportColliInventoryID ? rowData.TransportColliInventoryID : translations['short_not_assigned'] || 'n/a'}</Typography>;
            },
        },
        {
            title: translations["external_id"] || "External ID", field: 'ExternalID',
            hidden: visible ? visible['ExternalID'] : false,
            width: 100,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.PaletteExternalInfo && rowData.PaletteExternalInfo.length > 0 ? rowData.PaletteExternalInfo.map(paletteExternal => paletteExternal.ExternalID) : translations['short_not_assigned'] || 'n/a'}</Typography>;
            },
        },
        {
            title: translations['order_name'] || 'Order name', field: 'OrderName',
            hidden: visible ? visible['OrderName'] : false,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Order && rowData.Order.Name ? rowData.Order.Name : rowData.Order ? rowData.Order.OrderInventoryID : translations['short_not_assigned'] || 'n/a'}</Typography>;
            },
        },
        {
            title: translations["order_id"] || 'Order ID', field: 'OrderInventoryID',
            hidden: visible ? visible['OrderInventoryID'] : false,
            defaultFilter: `${defaultFilter && defaultFilter.OrderInventoryID ? defaultFilter.OrderInventoryID : ''}`,
            render: rowData => {
                return rowData.Order ?
                    <Button
                        color="primary"
                        variant="contained"
                        className={classes.paletteButtons}
                        href={`/logistic/orders?OrderInventoryID=${rowData.Order.OrderInventoryID}`}
                    >
                        <Typography variant={'caption'}>{rowData.Order.OrderInventoryID}</Typography>
                    </Button> : <Typography variant={'caption'}> n/a </Typography>;
            }
        },
        {
            title: translations["name"] || 'Name', field: 'Name',
            hidden: visible ? visible['Name'] : false,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Name ? rowData.Name : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["description"] || 'Description', field: 'Description',
            hidden: visible ? visible['Description'] : false,
            render: rowData => {
                return <> {rowData.Description && rowData.Description.length > 15 ?
                    <Tooltip key={`${rowData.Description}-${rowData.TransportColliID}`} title={rowData.Description}>
                        <Typography variant={'caption'}>{rowData.Description.slice(0, 14)}</Typography>
                    </Tooltip>
                    : <Typography variant={'caption'}>{rowData.Description ? rowData.Description : translations['short_not_assigned'] || 'n/a'}</Typography>}</>
            },
        },
        {
            title: translations["group"] || 'Group', field: 'GroupID',
            cellStyle: { minWidth: 100, maxWidth: 100 },
            hidden: visible ? visible['GroupID'] : false,
            lookup: groupsLookup,
            defaultFilter: defaultFilter?.GroupID ? [defaultFilter.GroupID] : groups ? Object.keys(groupsLookup) : [],
            render: rowData => {
                return <Typography style={{ fontSize: 12 }} gutterBottom>{rowData?.Group ? rowData.Group?.Name : (translations['short_not_assigned'] || 'n/a')}</Typography>
            }
        },
        {
            title: translations["arrived_at"] || 'Arrived', field: 'Arrived',
            hidden: visible ? visible['Arrived'] : false,
            filtering: false,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.ArrivedDate ? formatDate(rowData.ArrivedDate) : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
    ];

    const goToPCProducts = (_event, rowData) => {
        createHistory();
        setRedirectOptions({ redirect: true, transportColliID: rowData.TransportColliInventoryID, redirectPath: `/products/pc-products`, search: `TransportColliInventoryID=${rowData.TransportColliInventoryID}` });
    };

    const goToMobileProducts = (_event, rowData) => {
        createHistory();
        setRedirectOptions({ redirect: true, transportColliID: rowData.TransportColliInventoryID, redirectPath: `/products/mobile-products`, search: `TransportColliInventoryID=${rowData.TransportColliInventoryID}` });
    };

    const goToStorageProducts = (_event, rowData) => {
        createHistory();
        setRedirectOptions({ redirect: true, transportColliID: rowData.TransportColliInventoryID, redirectPath: `/products/storage-products`, search: `TransportColliInventoryID=${rowData.TransportColliInventoryID}` });
    };

    const goToHeadphoneProducts = (_event, rowData) => {
        createHistory();
        setRedirectOptions({ redirect: true, transportColliID: rowData.TransportColliInventoryID, redirectPath: `/products/headphone-products`, search: `TransportColliInventoryID=${rowData.TransportColliInventoryID}` });
    };

    const goToWatchProducts = (_event, rowData) => {
        createHistory();
        setRedirectOptions({ redirect: true, transportColliID: rowData.TransportColliInventoryID, redirectPath: `/products/watch-products`, search: `TransportColliInventoryID=${rowData.TransportColliInventoryID}` });
    };

    const goToTransportColliDetails = (_event, rowData) => {
        createHistory();
        setRedirectOptions({
            redirect: true, TransportColliID: rowData.TransportColliID, redirectPath: `/palettes/details`, search: `TransportColli=${rowData.TransportColliID}&&type=TransportColli`
        });
    };

    const generateBulkErasureReports = useCallback(async (formData) => {
        const exportFormatKeys = Object.keys(formData).filter(key => ["Excel", "JSON", "XML", "CSV"].includes(key));
        const exportFormats = [];
        for (const key of exportFormatKeys) {
            if (formData[key]) {
                const exportFormat = {};
                switch (key) {
                    case "Excel":
                        exportFormat.xlsx = { individualAssets: !!formData?.individualExcelReports };
                        break;
                    case "JSON":
                        exportFormat.json = { individualAssets: !!formData?.individualJsonReports };
                        break;
                    case "XML":
                        exportFormat.xml = { individualAssets: !!formData?.individualXmlReports };
                        break;
                    case "CSV":
                        exportFormat.csv = { individualAssets: !!formData?.individualCsvReports };
                        break;
                }
                exportFormats.push(exportFormat);
            }
        }

        const outputModes = Object.keys(formData).filter(key => ["Download", "Email"].includes(key)).filter((key) => formData[key]);

        const dataToSend = {
            ActiveCustomerID: activeCustomerID,
            CollectionType: 'transport_colli_collection',
            ExportFormats: exportFormats,
            OutputModes: outputModes.map(item => item.toLowerCase()),
            includePDFReports: formData.includePDFReports,
            includeAggregatedPDFErasureReports: formData.includeAggregatedPDFErasureReports,
            includeAggregatedPDFVerificationReports: formData.includeAggregatedPDFVerificationReports,
            includeSummaryPDFErasureReports: formData.includeSummaryPDFErasureReports,
            includeSummaryPDFVerificationReports: formData.includeSummaryPDFVerificationReports,
            includeDiagnoseReports: formData.includeDiagnoseReports,
            includeVerificationReports: formData.includeVerificationReports,
            GroupID: formData.GroupID,
            generateNew: formData.generateNew,
            CollectionTypeID: rowData.TransportColliID,     
        }
        await onBulkGenerateReport(dataToSend, translations);
        setCollectionCreatePopupIsOpen(false)
    }, [activeCustomerID, onBulkGenerateReport, rowData]);

    const goToCreateTransportColli = () => {
        createHistory();
        setRedirectOptions({ redirect: true, TransportColliID: null, redirectPath: `/palettes/transportColli/create`, search: '' });
    };

    const goToDeleteTransportColli = (transportColliIDs) => {
        createHistory();
        setRedirectOptions({ redirect: true, TransportColliID: transportColliIDs, redirectPath: `/palettes/transportColli/delete`, search: '' });
    };

    if (redirectOptions.redirect) {
        return <Redirect to={{
            pathname: redirectOptions.redirectPath,
            search: redirectOptions.search,
            state: { TransportColliID: redirectOptions.TransportColliID }
        }} />;
    }
    if (!hasAtLeastOnePermission(permissions, [
        "transport_colli_create",
        "transport_colli_load",
        "transport_colli_delete",
        "transport_colli_generate_report",
        "product_list"
    ])) {
        tableColumns.shift();
    }

    if (!activeExternalServiceAvailable) {
        if (tableColumns[0].field === 'Action') {
            tableColumns.splice(2, 1);
        } else {
            tableColumns.splice(1, 1);
        }
    }

    const loadingScreen = <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={checkIfLoading(loading)} PaperProps={{ classes: { root: classes.loading } }}>
        <AppLogoLoading />
    </Dialog>;

    return (
        <div className={classes.root}>
            {hasPermission(permissions, 'transport_colli_list') ?
                loading.groups ? loadingScreen :
                    <TransportColliList goToCreateTransportColli={goToCreateTransportColli} goToDeleteTransportColli={goToDeleteTransportColli} tableColumns={tableColumns} tableRef={tableRef} />
                : null
            }
            {
                <>
                    <Dialog classes={{ paper: classes.dialogPaper }} onClose={() => setCollectionCreatePopupIsOpen(false)} aria-labelledby="customized-dialog-title" open={collectionCreatePopupIsOpen} fullWidth={true}
                        maxWidth={'md'} >
                        <DialogTitle className={classes.title}>{`${translations["create_collection"] || "Create collection"}`} </DialogTitle>
                        <Grid container >
                            <Grid item xs={12}>
                                <ExportForm
                                    setIsOpen={collectionCreatePopupIsOpen}
                                    initialValues={initialValues}
                                    formSettings={formSettings}
                                    translations={translations}
                                    handleDownload={generateBulkErasureReports}
                                    groups={groupsLookup ? Object.keys(groupsLookup).map(key => ({ value: key, displayValue: groupsLookup[key] })) : []}
                                    showProductOverviewExportTypes={true}
                                    showProductOverviewOutputMode={true}
                                />
                            </Grid>
                        </Grid>
                    </Dialog>
                    {confirmDialog.open && <ConfirmationDialog
                        isOpen={confirmDialog.open}
                        title={confirmDialog.title}
                        contentText={translations['it_could_slow_down_live_message_sending'] || `It could slow down the sending of "live" messages to external systems.`}
                        onYes={() => setConfirmDialog({ open: false, confirmed: true, type: confirmDialog.type })}
                        onCancel={() => setConfirmDialog({ open: false, confirmed: false, type: confirmDialog.type })}
                        textCancel={translations['cancel'] || 'Cancel'}
                        textYes={translations['send'] || 'Send'}
                    />}
                </>
            }
        </div >
    );
}

const mapStateToProps = state => {
    return {
        permissions: state?.core?.login?.permissions || [],
        activeExternalServiceAvailable: state.core.login.activeExternalServiceAvailable,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onBulkGenerateReport: (transportColli, translations) => dispatch(actions.generateReports(transportColli, translations)),
        fetchGroups: params => dispatch(groupActions.fetchGroups(params)),
        onSendExternalData: params => dispatch(pcActions.sendExternalData(params)),
        onSendErasureReports: params => dispatch(pcActions.sendErasureReports(params)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(TransportColli));